import basketRoutes from './basket.routes';

import availabilitySliderComponent from './components/availability.slider.component';
import addGuestsComponent from './components/guests.add.component';
import selectOptionsComponent from './components/select.options.component';
import selectExtrasComponent from './components/select.extras.component';
import selectEventComponent from './components/select.event.component';
import addToBasketComponent from './components/basket.add.component';
import basketItemsComponent from './components/basket.items.component';
import basketCreateComponent from './components/basket.create.component';
import basketCreateTabsComponent from './components/basket.create.tabs.component';

import availabilitySliderController from './controllers/availability.slider.controller';
import addGuestsController from './controllers/guests.add.controller';
import selectOptionsController from './controllers/select.options.controller';
import selectExtrasController from './controllers/select.extras.controller';
import selectEventController from './controllers/select.event.controller';
import addToBasketController from './controllers/basket.add.controller';
import basketItemsController from './controllers/basket.items.controller';
import basketCreateController from './controllers/basket.create.controller';

import basketService from './services/basket.service';
import basketApiService from './services/basket.api.service';
import availabilityApiService from './services/availability.api.service';
import quantityApiService from './services/quantity.api.service';
import startTimeApiService from './services/startTime.api.service';

let basketModule = angular.module('spabooker.basket', ['spabooker.base', 'spabooker.shared.base', 'angular-flatpickr'])
    .config(basketRoutes)

    .component('availabilitySlider', availabilitySliderComponent)
    .component('addGuests', addGuestsComponent)
    .component('selectOptions', selectOptionsComponent)
    .component('selectExtras', selectExtrasComponent)
    .component('selectEvent', selectEventComponent)
    .component('addToBasket', addToBasketComponent)
    .component('basketItems', basketItemsComponent)
    .component('basketCreate', basketCreateComponent)
    .component('basketCreateTabs', basketCreateTabsComponent)

    .controller('availabilitySliderController', availabilitySliderController)
    .controller('addGuestsController', addGuestsController)
    .controller('selectOptionsController', selectOptionsController)
    .controller('selectExtrasController', selectExtrasController)
    .controller('selectEventController', selectEventController)
    .controller('addToBasketController', addToBasketController)
    .controller('basketItemsController', basketItemsController)
    .controller('basketCreateController', basketCreateController)

    .factory('basket', basketService)
    .factory('basketApiService', basketApiService)
    .factory('availabilityApiService', availabilityApiService)
    .factory('quantityApiService', quantityApiService)
    .factory('startTimeApiService', startTimeApiService)
    ;

export default basketModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/index.js